module.exports = __webpack_public_path__ + "static/media/banner_below_image_1.62f0efdc.svg";